export default __webpack_public_path__ + "static/media/instagram.170c4668.svg";